import * as React from "react";
import * as Ons from "react-onsenui";
import { isLoading, Loading } from "../Loading";
import { STRINGS } from "../strings";
import { AppCaregiverState } from "../system/AppState/AppCaregiverState";
import { translate } from "../translate";
import { getNotchCss } from "../utils/DeviceUtils";

interface RecruitmentMainScreenProps {
  onWorkingWithAnAgencyClick: () => void;
  onApplicationClick: () => void;
  onLaterClick: () => void;
  caregiver: AppCaregiverState | Loading;
}

export class RecruitmentMainScreen extends React.Component<RecruitmentMainScreenProps> {
  render() {
    if (isLoading(this.props.caregiver)) {
      return (
        <div className="RecruitmentMainScreen__root">
          <header
            className={`RecruitmentMainScreen__header ${getNotchCss(
              "RecruitmentMainScreen__header",
              ""
            )}`}
          >
            <div className="RecruitmentMainScreen__logo" />
          </header>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Ons.ProgressCircular indeterminate={true} />
          </div>
        </div>
      );
    }
    return (
      <div className="RecruitmentMainScreen__root">
        <header
          className={`RecruitmentMainScreen__header ${getNotchCss(
            "RecruitmentMainScreen__header",
            ""
          )}`}
        >
          <div className="RecruitmentMainScreen__logo" />
        </header>
        <main className="RecruitmentMainScreen__main">
          <p className="RecruitmentMainScreen__main_title">
            {translate(STRINGS.RECRUITMENT_MAIN_1)}
            <span className="RecruitmentMainScreen__main_bold">
              {" " + translate(STRINGS.RECRUITMENT_MAIN_1_2)}
              <br />
              {translate(STRINGS.RECRUITMENT_MAIN_2_1) + " "}
            </span>
            {translate(STRINGS.RECRUITMENT_MAIN_2)}.
          </p>

          <p className="RecruitmentMainScreen__main_margin-top-lg">
            {translate(STRINGS.RECRUITMENT_MAIN_3)}
            <br />
            {translate(STRINGS.RECRUITMENT_MAIN_4)}
          </p>

          <Ons.Button
            className="RecruitmentMainScreen__start"
            modifier={"large"}
            onClick={this.props.onApplicationClick}
          >
            {translate(STRINGS.START_APPLICATION)}
          </Ons.Button>
        </main>
        <footer className="RecruitmentMainScreen__footer">
          <Ons.Button modifier={"outline large"} onClick={this.props.onWorkingWithAnAgencyClick}>
            {translate(STRINGS.WORKING_WITH_AGENCY)}
          </Ons.Button>
          <hr />
          <Ons.Button
            className="RecruitmentMainScreen__main_margin-top-sm RecruitmentMainScreen__later"
            modifier={"large--quiet"}
            onClick={this.props.onLaterClick}
          >
            {translate(STRINGS.MAYBE_LATER)}
          </Ons.Button>
        </footer>
      </div>
    );
  }
}
